import { Component, Input, OnInit } from '@angular/core'

@Component({
	selector: 'app-list-of-products',
	templateUrl: './list-of-products.component.html',
	styleUrls: ['./list-of-products.component.scss'],
})
export class ListOfProductsComponent implements OnInit {
	constructor() {}

	slickConfig = {
		slidesToShow: 2.5,
		slidesToScroll: 2,
		dots: false,
		arrows: true,
		infinite: false,

		responsive: [
			{
				breakpoint: 950,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
				},
			},
		],
	}

	dataFiltered: any = []
	search: string = ''

	ngOnInit(): void {
		this.dataFiltered = this.data
	}

	numCardsDisplayed: number = 4

	loadMore() {
		this.numCardsDisplayed += 2
	}

	setSearch() {
		if (this.search) {
			this.dataFiltered = this.data.filter((item: any) => {
				if (
					this.resetString(item.name).includes(
						this.resetString(this.search)
					)
				) {
					return item
				}
			})
		} else {
			this.dataFiltered = this.data
		}
	}

	resetString(str: any) {
		return str
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036F]/g, '')
	}

	@Input() data: any
}
